import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"

const ButtonBase = styled.button.attrs(({ disabled, onClick }) => ({
  onClick: disabled ? undefined : onClick,
}))`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: ${0.5 * tokens.size.base}px;
  font-family: inherit;
  /* font-size: inherit; */
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border-radius: ${tokens.size.base};
  appearance: none;
  text-decoration: none;
  text-align: center;
  &:hover {
    // needed to override link styles
    text-decoration: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: default;
  }
  &:disabled svg {
    opacity: 0.6;
  }
`

ButtonBase.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export const Button = styled(ButtonBase)`
  color: ${tokens.color.white};
  background-color: ${tokens.color.primary};
  border: 1px solid ${tokens.color.primary};
  box-shadow: rgb(27 31 35 / 4%) 0px 1px 0px,
    rgb(255 255 255 / 25%) 0px 2px 0px inset;
  &:hover {
    background-color: ${tokens.color.primaryDark};
    border-color: ${tokens.color.primaryDark};
  }
  // focus must come before :active so that the active box shadow overrides
  &:focus {
    border-color: rgba(27, 31, 35, 0.15);
  }
  &:active {
    background-color: ${tokens.color.primaryDark};
  }
  &:disabled {
    color: ${tokens.color.text.muted};
  }
`

export const ButtonInvisible = styled(ButtonBase)`
  color: ${tokens.color.primary};
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  &:disabled {
    color: ${tokens.color.text.muted};
  }
  &:hover {
    color: ${tokens.color.primaryDark};
    /* border-color: ${tokens.color.primaryDark}; */
  }
`
